module.exports = __webpack_public_path__ + "static/media/control_2.65be0fd4.svg";